import { withPageAuthRequired } from "@common/middleware";
import { useCallback } from "react";
import MxWidget from "@modules/mx/components/Widget";
import { MxWidgetType } from "@modules/mx/types";
import { HiOutlineCog } from "react-icons/hi";
import useStore from "@common/state";
import useMxStore from "@modules/mx/state";
import ConnectionsWidgetDialog from "@modules/mx/components/ConnectionsWidgetDialog";
import TopNavbar from "@common/components/TopNavbar";

const AccountsPage = () => {
  const { showConnectionsDialog, setShowConnectionsDialog } = useStore();
  const { isMxZeroState } = useMxStore();

  const onClickAccountSettings = useCallback(() => {
    setShowConnectionsDialog(true);
  }, [setShowConnectionsDialog]);

  const onCloseConnectionsDialog = useCallback(() => {
    setShowConnectionsDialog(false);
  }, [setShowConnectionsDialog]);

  return (
    <div className="flex flex-1 flex-col">
      <ConnectionsWidgetDialog
        onClose={onCloseConnectionsDialog}
        isOpen={showConnectionsDialog}
      />
      <TopNavbar title="">
        {!isMxZeroState && (
          <div className="flex w-full flex-1 flex-row items-center justify-end">
            <button onClick={onClickAccountSettings}>
              <HiOutlineCog size={24} />
            </button>
          </div>
        )}
      </TopNavbar>
      <div className="flex flex-1">
        <MxWidget widgetType={MxWidgetType.accounts_widget} />
      </div>
    </div>
  );
};

export default withPageAuthRequired(AccountsPage);
